import { StrictDict } from '../../../utils';
import dropdown from './dropdown';
import multiSelect from './multiSelect';
import numeric from './numeric';
import singleSelect from './singleSelect';
import textInput from './textInput';

export default StrictDict({
  dropdown,
  multiSelect,
  numeric,
  singleSelect,
  textInput,
});
